import { Icon, IconName, type IconProps } from '../Icons';

type OrderPresetIconProps = Omit<IconProps, 'icon' | 'color'>;

export function OrderPresetIcon(props: OrderPresetIconProps) {
  return <Icon icon={IconName.Preferences} color="colors.orange.lighten" {...props} />;
}
